/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_HoldInputs */

const en_new_hold = /** @type {(inputs: New_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Hold`)
};

const es_new_hold = /** @type {(inputs: New_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo apartado`)
};

/**
* | output |
* | --- |
* | "New Hold" |
*
* @param {New_HoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const new_hold = /** @type {((inputs?: New_HoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_HoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_hold(inputs)
	return es_new_hold(inputs)
});